<template>
  <div class="d-content__section">
    <div class="heading">{{fbpRowData?fbpRowData.name:''}}</div>
    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
    <!-- {{fbpRowData}} -->
    <div class="twoColumnGrid margintop-30">
      <tl-checkbox
        label="Allow lower declaration"
        name="lowerDeclaration"
        :checked="fbpComponentsData.allow_lower_declaration"
        v-model="fbpComponentsData.allow_lower_declaration"
      ></tl-checkbox>
      <tl-checkbox
        label="Allow carry forward of low/excess bills"
        name="lowExcessBills"
        :checked="fbpComponentsData.allow_carry_forward_bills"
        v-model="fbpComponentsData.allow_carry_forward_bills"
      ></tl-checkbox>
      <tl-checkbox
        label="Allow carry forward of eligibility"
        name="forwordOfElegibiity"
        :checked="fbpComponentsData.allow_carry_forward_eligibility"
        v-model="fbpComponentsData.allow_carry_forward_eligibility"
      ></tl-checkbox>
      <tl-checkbox
        label="Allow adhoc full claims"
        name="adhocFullClaims"
        :checked="fbpComponentsData.allow_adhoc_full_claims"
        v-model="fbpComponentsData.allow_adhoc_full_claims"
      ></tl-checkbox>
      <tl-checkbox
        label="Allow annual claim"
        name="annualClaim"
        :checked="fbpComponentsData.allow_annual_claim"
        v-model="fbpComponentsData.allow_annual_claim"
      ></tl-checkbox>
      <div>
        <tl-checkbox
          label="Allow multiple claims"
          name="multipleClaims"
          :checked="fbpComponentsData.allow_multiple_claims"
          v-model="fbpComponentsData.allow_multiple_claims"
        ></tl-checkbox>
      </div>

      <tl-checkbox
        label="Map to taxable component"
        name="mapTaxableComponent"
        :checked="fbpComponentsData.map_to_taxable_component"
        v-model="fbpComponentsData.map_to_taxable_component"
      ></tl-checkbox>
    </div>
    <div class="row margintop-20" v-if="fbpComponentsData.map_to_taxable_component">
      <div class="col-2 marginleft-2p">
        <txt
          label="Taxable %"
          name="taxable"
          type="number"
          v-model="fbpComponentsData.taxable"
        />
      </div>
      <div class="col-2">
        <txt
          label="Non-Taxable %"
          name="nonTaxable"
          type="number"
          :value="(100-fbpComponentsData.taxable)"
          :disabled="true"
        />
      </div>
    </div><br>
    <div class="row margintop-20">
      <div class="col-3">
        <tl-select
          label="Process type"
          labelText="processType"
          :options="processTypeList"
          :value="fbpComponentsData.process_type"
          @change="(val)=>fbpComponentsData.process_type=val.value"
        ></tl-select>
      </div>
    </div><br>
    <!-- <div class="threeColumnGrid margintop-20"></div> -->
    <div class="threeColumnGrid">
      <tl-checkbox
        label="Allow auto claim"
        name="autoClaim"
        value="autoClaim"
        :checked="fbpComponentsData.allow_auto_claim"
        v-model="fbpComponentsData.allow_auto_claim"
      ></tl-checkbox>
    </div>
    <div class="row margintop-20">
      <div class="twocolumnGrid">
      <div>
        <tl-select
          label="Exclude FBP Components"
          labelText="componentName"
          :value="fbpComponentsData.FBPMutuallyExclusiveSalaryComponent"
          :options="mutuallyExclusiveComponents"
          @change="(val)=>esiComps(val, fbpComponentsData.FBPMutuallyExclusiveSalaryComponent)"
        ></tl-select>
      </div>
    </div>
    <div class="esiCompClass" v-if="tagsArray.length">
          <div class="selectedComp">
            <div v-for="(data,index) in tagsArray" :key="index">
            <div class="rect">
              <button v-show="showTag"> <span> {{ data.val.componentName }}  </span> </button>
            </div>
            </div>
          </div>
    </div>
      </div>
      <br>
    <div class="d-heading2">Component Mapping</div>
    <div class="row margintop-20">
      <div class="col-2">
        <tl-radio
          label="FBP Bands"
          name="componentMapping"
          id="fbpBands"
          value="fbpBands"
          v-model="componentType"
        ></tl-radio>
      </div>
      <div class="col-2">
        <tl-radio
          label="Grades"
          name="componentMapping"
          id="grades"
          value="grades"
          v-model="componentType"
        ></tl-radio>
      </div>
    </div>
    <div v-if="componentType == 'fbpBands'">
      <div v-for="(item, index) in bands" :key="index">
        <div class="row margintop-20">
          <div class="col-3">
            <tl-select
              label="Select FBP bands"
              labelText="name"
              :name="'fbpBands'+index"
              :value="item"
              :options="bandsDataList"
              @change="(val)=>{item.toCTC=val.toCtc
                item.fromCTC=val.fromCtc
                item.fbp_band_id=val.id}"
            ></tl-select>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-2">
            <txt
              label="From CTC (in rupees)"
              disabled="true"
              type="number"
              :name="'fromCTCBands'+index"
              :value="item.fromCTC"
              placeholder="0"
            />
          </div>
          <div class="col-2">
            <txt
              label="To CTC (in rupees)"
              disabled="true"
              type="number"
              :name="'toCTCBands'+index"
              :value="item.toCTC"
              placeholder="50000"
            />
          </div>
        </div>
        <div class="d-heading2 margintop-20">Calculation Type</div>
        <div class="row margintop-20">
          <div class="col-2">
            <tl-radio
              label="Flat"
              :name="'calculationTypeBands'+index"
              :id="'flatBands'+index"
              value="FLAT"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of CTC"
              :name="'calculationTypeBands'+index"
              :id="'ctcBands'+index"
              value="PERCENTAGE_OF_CTC"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of Basic"
              :name="'calculationTypeBands'+index"
              :id="'basicBands'+index"
              value="PERCENTAGE_OF_BASIC"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of Gross"
              :name="'calculationTypeBands'+index"
              :id="'grossBands'+index"
              value="PERCENTAGE_OF_GROSS"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-12 margintop-20">
            <txt label="Enter Value" type="number" :name="'valueBands'+index"
            v-model="item.value" />
          </div>
        </div>
        <div class="d-heading2 margintop-20">Maximum Limit</div>
        <div class="row margintop-20">
          <div class="col-12">
            <txt label="Enter Value" type="number" :name="'maxLimitBands'+index"
            v-model="item.max_amount" />
          </div>
        </div>
        <hr class="bandsSlab" v-if="bandsDataList.length != index+1" />
      </div>

      <div class="row-container align-center margintop-20">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="addBands">Add New FBP Band</button>
      </div>
    </div>
    <div v-if="componentType == 'grades'">
      <div v-for="(item, index) in grades" :key="index">
        <div class="row margintop-20">
          <div class="col-3">
            <tl-select
              label="Select Grades"
              labelText="componentName"
              :name="'grades'+index"
              :value="item"
              :options="mutuallyExclusiveComponents"
            ></tl-select>
          </div>
        </div>
        <div class="d-heading2 margintop-20">Calculation Type</div>
        <div class="row margintop-20">
          <div class="col-2">
            <tl-radio
              label="Flat"
              :name="'gradecalculationType'+index"
              :id="'flatGrades'+index"
              value="flat"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of CTC"
              :name="'gradecalculationType'+index"
              :id="'ctcGrades'+index"
              value="ctc"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of Basic"
              :name="'gradecalculationType'+index"
              :id="'basicGrades'+index"
              value="basic"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-2">
            <tl-radio
              label="% of Gross"
              :name="'gradecalculationType'+index"
              :id="'grossGrades'+index"
              value="gross"
              v-model="item.calculationType"
            ></tl-radio>
          </div>
          <div class="col-12 margintop-20">
            <txt label="Enter Value" type="number" :name="'valueGrades'+index" v-model="item.value" />
          </div>
        </div>
        <div class="d-heading2 margintop-20">Maximum Limit</div>
        <div class="row margintop-20">
          <div class="col-12">
            <txt label="Enter Value" type="number" :name="'maxLimitGrades'+index" v-model="item.maxLimit" />
          </div>
        </div>
        <hr class="bandsSlab" v-if="gradesDataList.length != index+1" />
      </div>
      <div class="row-container align-center margintop-20">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="addGrades">Add new Grades</button>
      </div>
    </div>
       <pop-up-message
         v-if="showpopup" 
         message="Fbp Component mapping done Successfully"
                 btnText="OK" @back="ok">
        </pop-up-message>
    <bottom-action-container class="position-fixed">
      <btn-grp slot="end">
        <btn text="Cancel" type="secondary" class @click="$emit('cancel',true)"></btn>
        <btn text="Save" type="primary" class @click="SaveData"></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
export default {
  name: "FbpComponents",
  props: {
    fbpRowData: Object
  },
  data() {
    return {
      componentType: '',
      showTag: false,
      showpopup:false,
      toast:false,
      errmsg:'',
      compArray: [],
      tagsArray: [],
      mutuallyExclusiveComponents: [
        {
          componentName: "Basic Salary",
          value: "basicSalary"
        },
        {
          componentName: "House Rent Allowance",
          value: "HouseRentAllowance"
        },
        {
          componentName: "Leave Travel Allowance",
          value: "leaveTravelAllowance"
        },
        {
          componentName: "Mobile / Telephone Reimbursement",
          value: "mobileTelephoneReimbursement"
        },
        {
          componentName: "Fuel & Vehicle Maintenance",
          value: "fuelVehicleMaintenance"
        },
        {
          componentName: "Car Allowance",
          value: "carAllowance"
        }
      ],
      processTypeList: [
        {
          processType: "Monthly",
          value: "MONTHLY"
        },
        {
          processType: "Quarterly",
          value: "QUARTERLY"
        },
        {
          processType: "Bi-annually",
          value: "BI_ANNUALLY"
        },
        {
          processType: "Annually",
          value: "ANNUALLY"
        }
      ],
      nontaxable:'',
      // taxable: "",
      fbpComponentsData: {
        allow_lower_declaration:false,
        allow_carry_forward_bills:false,
        allow_carry_forward_eligibility:false,
        allow_adhoc_full_claims:false,
        allow_annual_claim:false,
        allow_multiple_claims:false,
        map_to_taxable_component:false,
        process_type:'',
        allow_auto_claim:true,
      },
       bandsDataList: [],
       bands:[{
        fromCTC: "",
        toCTC: "",
        calculationType: "FLAT",
        value: ""
      }],
       grades:[{
        calculationType: "FLAT",
        value: ""
      }],
       fbpBands:[],
        gradesDataList: []
    };
  },
  watch:{
    componentType:function(val){
      if(val=='fbpBands'){
        this.fetchbands()
      }
      if(val=='grades'){
        this.fetchgrades()
      }
    }
  },
  activated(){
    if(this.fbpRowData){
      this.fbpComponentsData=this.fbpRowData
      //console.log('Activated',this.fbpComponentsData)
    }
  },
  mounted(){
     if(this.fbpRowData){
      this.fbpComponentsData=this.fbpRowData
      //console.log('mounted', this.fbpComponentsData)
    }
  },
  computed:{
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
          return this.getleid(0);
      }
    }
  },
  methods: {
    ...mapActions({
      act_fetchfbpbands: "onboard/fbpBands/fetchAll",
      act_updatecomponent:'dashboard/organisation/utilities/fbpsettings/updateComponent',
      act_fetchgrades:'onboard/salary_grades/fetchAll'
    }),
    async fetchbands(){
      try{
        let res =await this.act_fetchfbpbands()
        this.bandsDataList=res.data.payload.data
      }catch(err){
        //console.log(err)
      }
    },
    async fetchgrades(){
      try{
        let res =await this.act_fetchgrades()
        this.gradesDataList=res.data.payload.data
        //console.log('grades data',this.gradesDataList)
      }catch(err){
        //console.log(err)
      }
    },
    addBands() {
      this.bands.push({
        fromCTC: "",
        toCTC: "",
        calculationType: "FLAT",
        value: ""
      });
    },
    addGrades() {
      this.grades.push({
        calculationType: "FLAT",
        value: ""
      });
    },
    esiComps(val, data) {

      //console.log('selected comp', val)
      //console.log('selected data', data)
      // let obj ={
      //   obj.data = data
      // }
      this.tagData = data
        if (val) {
          let obj = {}
          obj.val = val
          this.compArray.push(obj);
          this.showTag = true
          this.tagsArray = this.compArray
        }
        else {
          this.$_.remove(this.compArray, function(value) {
            if(value.data === data){
              value.val = false
            }
          });
        }
        //console.log('comp array', this.compArray)
        this.tagsArray = this.compArray
        //console.log('tags array', this.tagsArray)
    },
     ok() {
      this.showpopup = false;
    },
    async SaveData() {
      // this.$emit("onSave", true);
      if(this.componentType=='fbpBands'){
        this.fbpComponentsData.isFbpBand=true
        this.fbpComponentsData.fbpBands=[]
        this.bands.forEach((item)=>{
          //console.log('fbpband',item)
          this.fbpComponentsData.fbpBands.push(item)
        })
          //console.log('fbpbands', this.fbpComponentsData.fbpBands)
        // this.fbpComponentsData.fbpBands=[]
        }
      if(this.componentType=='grades'){
        this.fbpComponentsData.isFbpGrade=true
        this.fbpComponentsData.fbpGrades=[]
        this.grades.forEach((item)=>{
          //console.log('fbpGrades',item)
          this.fbpComponentsData.fbpGrades.push(item)
        })
          //console.log('fbpGrades', this.fbpComponentsData.fbpBands)
        }
      if(this.fbpComponentsData.map_to_taxable_component){
        this.fbpComponentsData.taxable=this.fbpComponentsData.taxable
      }
      try{
        let id = this.fbpRowData.id
        // //console.log('leid', this.le_id)
        this.fbpComponentsData.le_id=this.le_id
        //console.log('fbpcomponents', this.fbpComponentsData)
        let res =await this.act_updatecomponent([id,this.fbpComponentsData])
        // this.bandsDataList=res.data.payload.data
        // add popup message
        //console.log('response update',res.status)
        if(res.status){
          this.showpopup=true
        }
      }catch(err){
        // //console.log(err)
        this.toast=true
          this.errmsg=err
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.heading {
  font-size: 14px;
  color: #646464;
  font-weight: 600;
}
.twocolumnGrid {
  width: 25%;
  margin-left: 15px;
  margin-right: 15px;
}
.bandsSlab {
  border: solid 1px #e4e4e4;
  margin-top: 30px;
}
.esiCompClass{
  max-width: 550px;
  max-height: 105px;
  margin-bottom: 2%;
}
.selectedComp {
  display: flex;
  flex-wrap: wrap;
  width: 538px;
  min-height: 80px;
  border-radius: 8px;
  border: solid 1px #dadada;
  background-color: #ffffff;
  margin-top: 1.1%;
}
.rect {
  padding: 5px 10px 5px 10px;
  margin: 2px;
  height: 30px;
  border-radius: 15px;
  background-color: #c7efef;
  text-align: center;
}
</style>
